import { createContext, useContext } from 'react';
import type { useInstallPrompt } from '@/lib/useInstallPrompt';
export const InstallContext = createContext<ReturnType<typeof useInstallPrompt> | null>(null);
export function usePwaInstall() {
  return useContext(InstallContext);
}
